<style lang="scss" scoped>
.address > div > div{
    padding: 5px
}
.top-title {
    background: white;
    display: flex;
    justify-content: space-between;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding: 5px 0;
    box-shadow: 0 0 8px #ddd;
}

/deep/ .text-wrap{
    max-height: 200px;
    overflow: auto;
}
</style>
<template>
	<section>
		<!-- <compSteplist v-if="isQuery" :type="'FBAOut'" :status="getStatus"></compSteplist> -->
        <div v-if="alertbox || type === 'query'" class="top-title">
            <Alert show-icon theme="info" style="display: inline-block; margin-bottom: 0">{{$t('fbb.fbatransfer.outtip', { defaultValue: 'FBA调出' })}}</Alert>
            <!-- <div class="bottom-button" v-if="alertbox">
                <vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme" class="margin-right-10">{{item.name}}</vButton>
            </div> -->
            <span >
                <vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme" class="margin-right-10">{{item.name}}</vButton>
            </span>
        </div>
        <div v-else>
            <Alert show-icon theme="info">{{$t('fbb.fbatransfer.outtip', { defaultValue: '单件换标默认贴产品标，换标后sku数量和换标前一致。拆箱入单件可自行选择是否贴产品标，换标后sku数量可输入供仓库参考。' })}}</Alert>
        </div>
        <div style="display: flex; margin-bottom: 10px">
            <div style="display: flex; flex-direction: column; height: 700px; width:calc(210%/3); margin-right:10px;">
                <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" :expand="false">
                    <compFormQuery v-if="isQuery" class="margin-layout" :formdata="getBase" :value="formData" placeholder="--" ></compFormQuery>
                    <compFormEdit v-else ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"></compFormEdit>
                </compWrapper>
                <compWrapper :title="$t('erp.b2c.product_information',{defaultValue:'产品信息'})" :expand="false" style="flex: 1">
		        	<compProduct class="margin-layout" ref="productlist" :activeid="id" :baseData="formData" :querytype="type" :skuData="productList" :isManage="manageStatus" @on-update="setProduct"></compProduct>
		        	<vButtonGroup slot="footer" v-if="!alertbox && type !== 'query'">
		        		<vButton v-for="item in getStatusBtns" :key="item.name" @click="item.run" :theme="item.theme">{{item.name}}</vButton>
		        	</vButtonGroup>
		        </compWrapper>
            </div>
            <div style="display: flex; flex-direction: column; height: 700px; width:calc(90%/3);">
                <compWrapper :title="$t('fbb.receiver.query',{defaultValue:'收货地址'})" :expand="false">
                    <vForm :label-width="100" ref="form" class="margin-15 clearfix address" :rules="getRules">
                        <Row style="border: 1px solid rgb(226, 232, 240)">
                            <Col style="border-right: 1px solid rgb(226, 232, 240);" span="12" v-if="deliveryAddress.receiveStore">{{deliveryAddress.receiveStore || '--'}}</Col>
                            <Col style="border-right: 1px solid rgb(226, 232, 240); color: #c5c8ce; " span="12" v-else>Code</Col>
                            <Col span="12" v-if="deliveryAddress.shipToCountry">{{deliveryAddress.shipToCountry || '--'}}</Col>
                            <Col span="12" v-else style="color: #c5c8ce; ">{{$t('erp.channelbase.country',{defaultValue:'国家'})}}</Col>
                        </Row>
                        <Row style="border: 1px solid rgb(226, 232, 240); border-top: none;">
                            <Col style="border-right: 1px solid rgb(226, 232, 240);" span="8" v-if="deliveryAddress.shipToState">{{deliveryAddress.shipToState || '--'}}</Col>
                            <Col style="border-right: 1px solid rgb(226, 232, 240); color: #c5c8ce;" span="8" v-else>{{$t('erp.b2c.state_province',{defaultValue:'州/省'})}}</Col>
                            <Col style="border-right: 1px solid rgb(226, 232, 240);" span="8" v-if="deliveryAddress.shipToCity">{{deliveryAddress.shipToCity || '--'}}</Col>
                            <Col style="border-right: 1px solid rgb(226, 232, 240); color: #c5c8ce;" v-else span="8">{{$t('erp.b2c.city',{defaultValue:'城市'})}}</Col>
                            <Col span="8" v-if="deliveryAddress.shipToPostal">{{deliveryAddress.shipToPostal || '--'}}</Col>
                            <Col span="8" v-else style="color: #c5c8ce;">{{$t('erp.b2c.zip_code',{defaultValue:'邮编'})}}</Col>
                        </Row>
                        <Row style="border: 1px solid rgb(226, 232, 240); border-top: none;">
                            <Col span="16" v-if="deliveryAddress.shipToPostal">{{deliveryAddress.shipToAddress1 || '--'}}</Col>
                            <Col span="16" v-else style="color: #c5c8ce;">{{$t('fbb.transfer.address',{defaultValue:'地址'})}}</Col>
                        </Row>
                        <Row style="border: 1px solid rgb(226, 232, 240); border-top: none;">
                            <Col style="border-right: 1px solid rgb(226, 232, 240)" span="12" v-if="deliveryAddress.shipToContact">{{deliveryAddress.shipToContact || '--'}}</Col>
                            <Col style="border-right: 1px solid rgb(226, 232, 240); color: #c5c8ce;" span="12" v-else>{{$t('fbb.headlogistics.factory_contact', { defaultValue: '联系人' })}}</Col>
                            <Col span="12" v-if="deliveryAddress.shipToTelephone">{{deliveryAddress.shipToTelephone || '--'}}</Col>
                            <Col span="12" v-else style="color: #c5c8ce;">{{$t("erp.b2c.phone", { defaultValue: "电话" })}}</Col>
                        </Row>
                    </vForm>
                </compWrapper>
                <compWrapper :title="$t('global.common.attache',{defaultValue:'附件信息'})" :expand="false" style="flex: 1">
                    <compAttach class="margin-layout" ref="attachlist" :data="attachList" :activeid="id" :isManage="manageStatus" @on-update="setAttach"></compAttach>
                </compWrapper>
            </div>
        </div>
        <compPhotoLog v-if="type === 'query'" v-bind="photoData"></compPhotoLog>
		<compWrapper v-if="type==='query'" :title="$t('global.log.name',{defaultValue:'操作历史'})">
			<vTable class="margin-15" :columns="getLogColumns" :data="logList" border></vTable>
		</compWrapper>
        <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="closemodalprops" @on-confirm="modalProps.show=false">
			<component v-if="modalProps.component" :is="modalProps.component" v-bind="modalProps.props" @on-close="closemodalprops" v-on="modalProps.on"/>
		</compModal>
        <compModal v-model="showModal" v-bind="getApporveProps" @on-close="showModal=false" @on-confirm="cancel"></compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpAllotAddress, HttpTransferPlanCreate, HttpTransferPlanUpdate, HttpCreateTruck } from '@/service/misc';
import {
    HttpPlanBill,
    HttpSubPlanBill,
    HttpSubmiPlanBill,
    HttpCancelPlanBill,
    HttpAllSureBill,
    HttpRetryWms,
    HttpRebackAuditPlanBill,
    HttpReprocessPlanBill,
    HttpBackToNormalPlanBill,
    HttpSubApprovePlanBill,
    HttpCompletePlanBill,
    HttpSubPlanGet,
    HttpCheckWarehouse
} from "@/service/allotment";
import { mapGetters } from 'vuex';
import compProduct from './productout';
import compAttach from './attach';
import compSteplist from '../steplist';
import compPhotoLog from '../photolog.vue'
import mixin from "../mixin";

export default {
	mixins: [mixin],
	props: ['activeid', 'querytype', 'alertbox', 'isManage'],
	components: {
		compProduct,
        compAttach,
        compSteplist,
        compPhotoLog
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
			formData: {
                inventoryType: 0,
			},
            showRel: false,
            checkWarehouse:false,
            manageStatus: this.isManage || this.$route.query.isManage || false,
            deliveryAddress: [],
			productList: [],
			attachList: [],
			logList: [],
            transferOutboundPlanEntity: [],
            photoData: {},
            modalProps: {
				show: false,
			},
            showModal: false,
		};
	},
	async created() {
        // 添加权限
		this.perUpdate = this.handleAuth('fbb.inboundplan.update');
        this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getProductList', 'getOrgList', 'getCountryList', 'getUserManageWarehouseList', 'getFBBFilterDisabledAllWarehouse', 'getBillcusWareList']),
		getStatus() {
            const status = this.manageStatus ? this.formData.subTransferPlanStatus :this.formData.transferOutboundPlanStatus
			return this.type !== 'add' && status
		},
		isEdit() {
			return this.type === 'edit'
		},
		isQuery() {
			return this.type === 'query'
		},
		isAdd() {
			return this.type === 'add'
		},
        getRules() {
			return this.type === 'query' ? [] : {
				['*']: {
					required: true,
					message: this.$t("global.common.required", { defaultValue: "该信息不能为空,请填写",}),
				}
			}
		},
		// 根据状态显示不同按钮
		getStatusBtns() {
			const getStatus = this.getStatus;
			const btn = [
                {
                    name: this.$t('global.common.return', { defaultValue: '返回' }),
                    show: !this.alertbox,
                    run: this.cancel
                },
                {
                    name: this.$t('global.common.operation_cancel', { defaultValue: "取消" }),
                    show: this.isQuery && !this.manageStatus && (getStatus == 0 || getStatus == 3 || getStatus == 5 || getStatus == 6 || getStatus == 8 || getStatus == 9 || getStatus == 10 || (getStatus == 20 && this.formData.orderType !== 0 ) || getStatus == 120) ,
                    run: this.cancelOperate
                },
                {
                    name: this.$t('fbb.inbound.save_draft', { defaultValue: '保存为草稿' }),
                    show: this.isAdd || this.isEdit ,
                    run: this.save
                },
                {
                    name: this.$t('fbb.alloment.save_and_commit',{defaultValue:'保存并提交'}),
                    show: (this.isAdd || this.isEdit ) && this.perUpdate,
                    theme: 'primary',
                    run: this.saveAndSubmit
                },
                {
                    name: this.$t('fbb.inbound.submit_audit', { defaultValue: '提交审核'}),
                    show: !this.manageStatus && this.isQuery && (getStatus == 0 || getStatus == 3) && this.perUpdate,
                    theme: 'primary',
                    run: this.submit
                },
                {
                    name: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核"}),
                    show: !this.manageStatus && getStatus == 5 && this.perUpdate,
                    run: this.cancelSubmit
                },
                {
                    name: this.$t('fbb.alloment.button_audit', { defaultValue: '审核'}),
                    show: this.manageStatus && getStatus == 5,
                    theme: 'primary',
                    run: this.approve
                },
                {
                    name: this.$t('fbb.inbound.repush_warehouse', { defaultValue: '重推仓库' }),
                    show: this.manageStatus && (getStatus == 9 || getStatus == 10 || getStatus == 20) && this.perUpdate,
                    run: this.repushWms,
                },
                {
                    name: this.$t('global.datepicker.confirm', { defaultValue: '确认' }),
                    show: !this.manageStatus && getStatus == 8 && this.perUpdate,
                    run: this.sure
                },
                {
                    name: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                    show: this.isQuery && this.formData.errorCode !== 0 && this.perUpdate,
                    run: this.reprocess
                },
                {
                    name: this.$t('fbb.alloment.back_to_normal', { defaultValue: "忽略异常" }),
                    show: this.isQuery && this.formData.errorCode !== 0 && this.perUpdate,
                    run: this.backToNormal
                },
                {
                    name: this.$t('global.common.finish', { defaultValue: '完成'} ),
                    show: this.manageStatus && getStatus == 10 || getStatus == 15 || getStatus == 20 || getStatus == 25,
                    theme: 'primary',
                    run: this.submitComplete
                },
			]
			return btn.filter(item => item.show);
		},
		getBase() {
			return [
                {
                    label: this.$t('fbb.allotment.bill', { defaultValue: "调拨计划单号" }),
                    key: "transferOutboundPlanNo",
                    query: true,
                    show: this.type !== "add" && !this.manageStatus,
                    render: h => {
                        const { transferOutboundPlanStatus, transferOutboundPlanNo, errorCode} = this.formData;
                        const data =this.getFbaBillStatusSelect.find( item => item.value === transferOutboundPlanStatus) || {};
                        return (
                          <div>
                              {transferOutboundPlanNo}
                              <vButton ghost theme={data.theme} style="margin-left:5px;padding:1px 10px;cursor:unset;">
                                  {data.label}
                              </vButton>
                              <span style="margin-left:5px;color:red;">{this.findRenderLabel(this.getErrorSimpleType, errorCode)} </span>
                          </div>
                        );
                    }
                },
                {
                    label: this.$t('fbb.allotment.bill', { defaultValue: "调拨计划单号" }),
                    key: "subTransferPlanNo",
                    query: true,
                    show: this.manageStatus,
                    render: (h) => {
                        const { subTransferPlanStatus, subTransferPlanNo, errorCode} = this.formData;
                        const data =this.getFbaBillStatusSelect.find( item => item.value === subTransferPlanStatus) || {};
                        return (
                          <div>
                              {subTransferPlanNo}
                              <vButton ghost theme={data.theme} style="margin-left:5px;padding:1px 10px;cursor:unset;">
                                  {data.label}
                              </vButton>
                              <span style="margin-left:5px;color:red;">{this.findRenderLabel(this.getErrorSimpleType, errorCode)} </span>
                          </div>
                        );
                    }
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: "organizationId",
                    options: this.getOrgList,
                    show: this.manageStatus,
                },
                {
                    label: this.$t('fbb.alloment.alloment_type', { defaultValue: "调拨类型" }),
                    render: (h)=>{
                        return <div>
                            {this.formData.orderType === 1 ? this.$t('fbb.alloment.alloment_out', { defaultValue: '调拨出库' }) : this.$t('fbb.alloment.alloment_in', { defaultValue: '调拨入库' }) || '--'}({ this.findRenderLabel(this.getFbaBillType, this.transferOutboundPlanEntity.orderType) } )
                        </div>
                    },
                    show: this.manageStatus,
                },
                {
                    label: this.$t('fbb.alloment.in_warehouse', { defaultValue: "调入仓库" }),
                    key: 'inOrgWarehouseId',
                    tag: 'vSelect',
                    options: this.getFBBFilterDisabledAllWarehouse.filter(item=>item.attach.warehouseType === 1),
                    props: {
                        filterable: true,
                    },
                    on: {
                        'on-change': (val) => this.handleInWarehouse(val)
                    },
                    show: !this.manageStatus,
                },
                {
                    label: this.$t('fbb.alloment.in_warehouse', { defaultValue: "调入仓库" }),
                    key: 'inOrgWarehouseCode',
                    tag: 'vSelect',
                    options: this.getBillcusWareList.map(item=>{
                        return {
                            value: item.attach.code,
                            label: item.label
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    on: {
                        'on-change': (val) => this.handleInWarehouse(val)
                    },
                    show: this.manageStatus,
                },
                {
                    label: "Remove Order ID",
                    key: 'removeOrderId',
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.alloment.expect_in_bound_time', { defaultValue: "期望入库日期" }),
                    key: 'estimateInboundAt',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd',
                        confirm: false,
                    },
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    key: 'inventoryType',
                    tag: 'vRadio',
                    options:[
                        {
                            trueValue: 0,
                            label: this.$t('fbb.inbound.available_stock', { defaultValue: '可售库存' })
                        }, {
                            trueValue: 1,
                            label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' })
                        }
                    ]
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: "lineId",
                    tag: "vSelect",
                    options: this.getProductList.map((item) => {
                        return {
                            value: item.value,
                            label: item.attach.name,
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    required: false,
                    show: !this.manageStatus,
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: "lineName",
                    show: this.manageStatus,
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    key: 'sourceNo',
                    tag: 'vInput',
                    props: {
                        placeholder: this.$t('fbb.transfer.record_receipt_plan_no', { defaultValue: "可记录入库计划单号等" }),
                    },
                    required: false,
                },
                {
                    label: this.$t('global.common.notes', { defaultValue: "备注" }),
                    tag: "vTextarea",
                    key: "remark",
                    span: 12,
                    required: false,
                },
                {
                    label: this.$t('fbb.alloment.transfer_plan_no', { defaultValue: "关联调拨计划单号" }),
                    key: "transferPlanRelNo",
                    show: this.manageStatus && !this.showRel && this.checkWarehouse,
                    render: (h) => {
                        const { subRelTransferPlanStatus, transferPlanRelNo, transferPlanRelId, subRelOrgWarehouseCode } = this.formData;
                        const data = this.getFbaBillStatusSelect.find(item => item.value === subRelTransferPlanStatus ) || {};
                        if(this.formData.transferPlanRelId){
                            return <div>
                                <a onClick={this.handleOperates.bind( this, transferPlanRelId, "query" )}>
                                  {transferPlanRelNo || "-"} ({subRelOrgWarehouseCode || "-"})
                                </a>
                                <vButton ghost theme={data.theme} style="margin-left:5px;padding:1px 10px;cursor:unset;">
                                  {data.label}
                                </vButton>
                            </div>
                        } else{
                            return '--'
                        }
                    },
                    span: 24,
                },
                {
                    label: this.$t('fbb.alloment.transfer_plan_no', { defaultValue: "关联调拨计划单号" }),
                    key: "transferPlanRelNo",
                    show: this.manageStatus && !this.showRel && !this.checkWarehouse,
                    render: (h) => {
                        const { subRelTransferPlanStatus, transferPlanRelNo, subRelOrgWarehouseCode } = this.formData;
                        const data = this.getFbaBillStatusSelect.find( item => item.value === subRelTransferPlanStatus ) || {};
                        if(this.formData.transferPlanRelId){
                            return <div>
                                <span>
                                    {transferPlanRelNo || "--"} ({subRelOrgWarehouseCode || "--"})
                                </span>
                                <vButton ghost theme={data.theme} style="margin-left:5px;padding:1px 10px;cursor:unset;">
                                    {data.label}
                                </vButton>
                            </div>
                        } else{
                            return '--'
                        }
                    },
                    span: 24,
                }
			];
		},
		getLogColumns() {
			return [
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    key: 'opAction',
                    render: (h, { row }) => {
                        return this.getLogActions[row.operateType] || '';
                    },
                },
                {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: 'remark',
                    width: "30%"
                },
                {
                    title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
                    key: 'createdAt',
                },
            ];
		},
        getApporveProps() {
            return {
                alert: "info",
                title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                width: "middle",
                showDesc: false,
                params: {
                    ids: this.id
                },
                ajaxRequest: HttpSubApprovePlanBill,
                formdata: [
                    {
                        tag: "vRadio",
                        key: "actionType",
                        span: 24,
                        label: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                        labelWidth: 120,
                        default: 500,
                        options: [
                            {
                                label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                                trueValue: 500
                            },
                            {
                                label: this.$t('fbb.inbound.back_audit', { defaultValue: "审核拒回" }),
                                trueValue: 600
                            }
                        ]
                    },
                    {
                        label: this.$t('fbb.alloment.warehouse_out_bound_at', { defaultValue: "预计出库日期" }),
                        tag: "vDatepicker",
                        key: "warehouseEstimateOutboundAt",
                        labelWidth: 120,
                        show:this.formData.orderType==1,
                        span: 24,
                        props: {
                            format: "yy-mm-dd"
                        },
                        required: false
                    },
                    {
                        tag: "vTextarea",
                        key: "reason",
                        span: 24,
                        label: this.$t('global.common.notes', { defaultValue: "备注" }),
                        required: false
                    }
                ]
            };
        },
	},
	methods: {
        closemodalprops(){
            this.modalProps = {};
            this.$emit('on-openCloseable');
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case "query":
                    var url = this.$router.resolve({
                      name: "fbaTransferOutDetail",
                      params: { type: "query" },
                      query: { id: params, isManage: true }
                    });
                    window.open(url.href, "_blank");
                    break;
            }
        },
        async getDetail() {
            if (this.type === "add") return;
            this.loading = true;
            const ajaxRequest = this.manageStatus ? HttpSubPlanBill : HttpPlanBill;
            return ajaxRequest({ id: this.id }).then(res => {
                this.loading = false;
                const data = res.data,
                body = data.transferOutboundPlanEntity;
                this.attachList = data.orderAttachesEntities || [];
                this.productList = body.transferOutboundPlanItemList || [];
                this.transferOutboundPlanEntity = data.transferOutboundPlanEntity
                this.logList = data.orderLogEntityList || [];
                this.formData = this.manageStatus ? {...data.transferOutboundPlanEntity, ...data.subTransferPlansEntity} : data.transferOutboundPlanEntity || [];
                this.photoData.orderData = this.formData;
                this.photoData.orderType = 1;
                this.deliveryAddress = {
                    receiveStore: this.formData.receiveStore || '--',
                    shipToCountry: this.formData.shipToCountry || '--',
                    shipToState: this.formData.shipToState || '--',
                    shipToCity: this.formData.shipToCity || '--',
                    shipToPostal: this.formData.shipToPostal || '--',
                    shipToAddress1: this.formData.shipToAddress1 || '--',
                    shipToContact: this.formData.shipToContact || '--',
                    shipToTelephone: this.formData.shipToTelephone || '--',
                    truckCompany: this.formData.truckCompany || '--',
                    pickupTime:this.formData.pickupTime || '--',
                };
                if(this.formData.transferPlanRelId){
                    this.loading = true;
                    this.showRel = false;
                    //关联单据
                    HttpSubPlanGet({ id: this.formData.transferPlanRelId})
                        .then(res => {
                            this.loading = false;
                            this.formData.subRelTransferPlanStatus = res.data.subTransferPlanStatus;
                            this.formData.subRelOrgWarehouseCode = res.data.orgWarehouseCode;
                        }).catch(err => {
                            this.$Message.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        });
                    HttpCheckWarehouse({ id: this.formData.transferPlanRelId, contextId: global.SYSID,})
                        .then(res => {
                            if(res.data === true){
                                this.checkWarehouse= true;
                            }
                            this.loading = false;
                        }).catch(err => {
                            this.$Message.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        });
                }else {
                    this.showRel = true;
                }
                if(!this.manageStatus){
                    this.handleInWarehouse(this.formData.inOrgWarehouseId)
                }
            }).catch(err => {
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            });
        },
        handleInWarehouse(val){
            if(!val) {
                this.deliveryAddress = {};
                return
            }
            const wareHouse = this.getFBBFilterDisabledAllWarehouse.filter(item=>item.value == val)[0];
            this.formData.inOrgWarehouseCode = wareHouse.attach.code;
            this.getAddress(val);
        },
        //详细地址
		async getAddress(data) {
            this.loading = true;
			HttpAllotAddress({warehouseId: data}).then(res => {
                this.loading = false;
				const { code, country, state, city, postal, address, linkman, phone } = res.data;
				this.deliveryAddress = {receiveStore: code, shipToCountry: country, shipToState: state, shipToCity: city, shipToPostal: postal, shipToAddress1:address, shipToContact:linkman, shipToTelephone: phone};
			}), err => {
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
			};
		},
        setProduct(arr) {
            if(arr[0] && arr[0].lineId){
                this.$set(this.formData, 'lineId', arr[0].lineId)
            }
            this.productList = arr;
        },
        setAttach(arr) {
            this.attachList = arr;
        },
		//保存为草稿
		async save() {
            const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            this.formData.orderType = 0;
            this.formData.orgWarehouseId = 0;
            this.formData.orgWarehouseCode = 'Other';
            if(this.productList.length == 0){
                this.$Message.error({
                    content: this.$t('fbb.transfer.add_sku_check', { defaultValue: '请添加SKU信息！' }),
                    duration: 30,
                    closable: true,
                });
                return
            }
            for(let i = 0; i < this.productList.length; i++){
                if(!this.productList[i].sku || !this.productList[i].qty){
                    this.$Message.warning({
                        content: this.$t('fbb.transfer.add_sku_out_amount_check', { defaultValue: '请填写sku和计划出库数量！' }),
                        duration: 30,
                        closable: true,
                    });
                    return
                }
            }
            this.formData = {...this.formData, ...this.deliveryAddress, transferOutboundPlanItemModelList: this.productList, transferOrderAttachModelList: this.attachList};
            this.loading = true;
            const ajaxRequest = this.isAdd ? HttpTransferPlanCreate : HttpTransferPlanUpdate;
            return ajaxRequest({...this.formData, id: this.id}).then(res=>{
                this.loading = false;
                this.$Message.success({
                    content: res.message,
                    duration: 30,
                    closable: true,
                });
                this.cancel();
            }, err =>{
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            });
		},
		//保存提交
		async saveAndSubmit() {
            const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            this.formData.orderType = 0;
            this.formData.orgWarehouseId = 0;
            this.formData.orgWarehouseCode = 'Other';
            if(this.productList.length == 0){
                this.$Message.error({
                    content: this.$t('fbb.transfer.add_sku_check', { defaultValue: '请添加SKU信息！' }),
                    duration: 30,
                    closable: true,
                });
                return
            }
            for(let i = 0; i < this.productList.length; i++){
                if(!this.productList[i].sku || !this.productList[i].qty){
                    this.$Message.warning({
                        content: this.$t('fbb.transfer.add_sku_out_amount_check', { defaultValue: '请填写sku和计划出库数量！' }),
                        duration: 30,
                        closable: true,
                    });
                    return
                }
            }
            this.formData = {...this.formData, ...this.deliveryAddress, transferOutboundPlanItemModelList: this.productList, transferOrderAttachModelList: this.attachList};
            this.loading = true;
            const ajaxRequest = this.isAdd ? HttpTransferPlanCreate : HttpTransferPlanUpdate;
            return ajaxRequest({...this.formData, id: this.id}).then(res=>{
                HttpSubmiPlanBill({ id: res.data.id }).then(
                    res => {
                        this.loading = false;
                        this.$Message.success({
                            content: res.message,
                            duration: 30,
                            closable: true,
                        });
                        this.cancel();
                    },
                    err => {
                        this.loading = false;
                        this.$Message.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }, err =>{
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            });

		},
		// 提交审核
		async submit() {
            this.loading = true;
            HttpSubmiPlanBill({ id: this.id }).then(
                res => {
                    this.loading = false;
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    this.cancel();
                },
                err => {
                    this.loading = false;
                    this.$Message.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
		},
        // 撤销审核
        async cancelSubmit(){
            this.modalProps = {
                title: this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
                showDesc: true,
                alert: 'warning',
                show: true,
                params: {
                    id: this.id
                },
                ajaxRequest: HttpRebackAuditPlanBill,
                callback: (res) => {
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    this.cancel();
                }
            }
        },
        // 审核
        approve(){
            this.showModal = true
        },
        //完成
        async submitComplete() {
            this.modalProps = {
                show: true,
                alert: "primary",
                showDesc: false,
                title: this.$t('global.common.finish', { defaultValue: "完成" }),
                params: { id: this.id },
                formdata: [
                  {
                    tag: "vTextarea",
                    key: "completeReason",
                    labelWidth: "auto",
                    span: 24,
                    label: this.$t('fbb.alloment.finish_reason', { defaultValue: "完成原因" })
                  }
                ],
                ajaxRequest: HttpCompletePlanBill,
                callback: this.cancel
            };
        },
        // 取消
        async cancelOperate(){
            this.modalProps = {
                title: this.$t('global.common.operation_cancel', { defaultValue: "取消" }),
                showDesc: true,
                alert: 'warning',
                show: true,
                params: {
                    id: this.id
                },
                ajaxRequest: HttpCancelPlanBill,
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "cancelReason",
                        labelWidth: "auto",
                        span: 24,
                        label: this.$t('fbb.alloment.cancel_reason', { defaultValue: "取消原因" })
                    }
                ],
                callback: (res) => {
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    this.cancel();
                }
            }
        },
        // 重推WMS
        repushWms(){
			this.loading = true;
			HttpRetryWms({ id: this.id }).then(res => {
				this.loading = false;
                this.$Message.success({
                    content: res.message,
                    duration: 30,
                    closable: true,
                });
			}).catch(err => {
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
				this.loading = false;
			})
		},
        // 确认
        sure() {
            this.modalProps = {
                title: this.$t('global.datepicker.confirm', { defaultValue: "确认" }),
                showDesc: true,
                alert: 'primary',
                show: true,
                params: {
                    id: this.id
                },
                ajaxRequest: HttpAllSureBill,
                formdata: [
                    {
                      tag: "vTextarea",
                      key: "remark",
                      labelWidth: "auto",
                      span: 24,
                      label: this.$t('global.common.notes', { defaultValue: "备注" }),
                      required: false,
                    }
                ],
                callback: (res) => {
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    this.cancel();
                }
            }
        },
        // 重处理
        reprocess(){
            this.modalProps = {
                show: true,
                alert: "info",
                title: this.$t('fbb.alloment.reprocess', { defaultValue: "重处理" }),
                width: 400,
                showDesc: true,
                params: {
                    id: this.id,
                    type: this.manageStatus ? 2 : 1
                },
                ajaxRequest: HttpReprocessPlanBill,
                callback: this.cancel
            };
        },
        // 忽略异常
        backToNormal(){
            this.modalProps = {
                show: true,
                alert: "info",
                title: this.$t('fbb.alloment.back_to_normal', { defaultValue: "忽略异常" }),
                width: 400,
                showDesc: true,
                params: {
                    id: this.id,
                    type: this.manageStatus ? 2 : 1
                },
                ajaxRequest: HttpBackToNormalPlanBill,
                callback: this.cancel
            };
        },
		cancel() {
			if (this.alertbox) {
                this.$emit("on-update");
				this.$emit('on-close')
			} else {
				this.$router.push({name: this.manageStatus ? 'transferManageList' : 'fbaTransferList'})
			}
		},
	}
};
</script>
